import { useTranslation } from 'react-i18next';

/**
 * Кнопка «⋯» 44 px в строке списка сотрудника на телефоне (правило 4 docs/CURATOR-MOBILE-DESIGN.md §3): открывает лист
 * действий строки (`ActionSheet`). Одна разметка на все экраны шагов 8–9 — прежде та же кнопка копировалась в каждый
 * экран руками.
 */
export function MoreButton({ onClick }: { onClick: () => void }) {
  const { t } = useTranslation();
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={t('nav.more')}
      data-more-button
      className="grid h-11 w-11 flex-none place-items-center rounded-full text-on-surface-variant"
    >
      <span className="material-symbols-outlined text-[20px]">more_horiz</span>
    </button>
  );
}
